import { SensitiveDataApiService, WatchlistApiService } from '@nk/api-lib';
import { Observable, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

/**
 * Resolves to true when the current user has sensitive data access for the
 * given company — either granted directly at the company level, or granted at
 * the watchlist level for any watchlist the company belongs to.
 */
export function getCompanySensitiveDataAccess(
  companyUuid: string,
  appCustomerUuid: string,
  sensitiveDataService: SensitiveDataApiService,
  watchlistService: WatchlistApiService,
): Observable<boolean> {
  return watchlistService.fetchWatchlistsByCompanyAndCustomer(appCustomerUuid, companyUuid).pipe(
    map((watchlists) => watchlists?.map((w) => w.uuid) ?? []),
    switchMap((watchlistUuids) =>
      sensitiveDataService.sensitiveDataWatchlistAccessEntityListCache
        .get()
        .pipe(map((entities) => entities.some((i) => watchlistUuids.includes(i.watchlist_uuid)))),
    ),
    switchMap((hasWatchlistAccess) =>
      hasWatchlistAccess
        ? of(true)
        : sensitiveDataService.sensitiveDataCompanyAccessEntityListCache
            .get()
            .pipe(map((entities) => entities.some((i) => i.company_uuid === companyUuid))),
    ),
  );
}
